import React from 'react';

const UserProvider = React.createContext<[any, any]>([{}, {}]);

export default UserProvider;